/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
import { AdcsApiService, SecurityApiService } from '../../../shared/http';
import { AdcsUtilsService, NamespaceService } from '../../../shared/services/utils';
import { BaseComponent } from '../../../../../core/components';
import { Component } from '@angular/core';
import { ErrorResponseModel } from '../../../../../core/models';
import { LogService, RbacService } from '../../../../../core/services';
import { takeUntil } from 'rxjs/operators';
import { forkJoin } from 'rxjs';

@Component({
    selector: 'app-certificates',
    templateUrl: './certificates.component.html',
    styleUrls: ['./certificates.component.scss']
})
export class CertificatesComponent extends BaseComponent {
    /**
     * Has tier
     */
    public hasTier: boolean = false;

    /**
     * Flag on loading state.
     */
    public isLoading: boolean = true;

    /**
     * Namespace selected key.
     */
    public selectedNamespaceKey: number;

    /**
     * Table row data.
     */
    public tableRows: any[] = [];

    /**
     * Store permissions in lookup table.
     */
    public permissionsLookup: any = {};

    constructor(
        public adcUtilsService: AdcsUtilsService,
        private adcApiService: AdcsApiService,
        private logService: LogService,
        private namespaceService: NamespaceService,
        private rbacService: RbacService,
        private securityApiService: SecurityApiService
    ) {
        super();

        this.hasTier = this.rbacService.getPageRequiredRoute('/api/v1/:namespace/security/certificates')?.tier;
        this.selectedNamespaceKey = this.namespaceService.selectedNamespace.key;

        this.setUpPageData();
        this.registerButtons();
    }

    /**
     * Set up the page data.
     * @private
     */
    private setUpPageData(): void {
        const apiCalls = {
            adcs: this.adcApiService.getAll(this.selectedNamespaceKey),
            // certificates: this.securityApiService.getAllCertificates(this.selectedNamespaceKey)
        };

        forkJoin(apiCalls)
            .pipe(takeUntil(this.destroyed$))
            .subscribe({
                    next: (dataGroup: any): void => {
                        this.populateTableRows(dataGroup);
                        this.isLoading = false;
                    },
                    error: (error: ErrorResponseModel): void => {
                        this.logService.error(
                            'CertificatesComponent:setUpPageData',
                            'Unable to get page data. ' + error.message
                        );
                    }
                }
            );
    }

    /**
     * Populate table rows.
     * @private
     */
    private populateTableRows(data: any): void {
        // const certs: any[] = data.certificates || [];
        this.tableRows = [];

        if (data.adcs?.length) {
            for (const adc of data.adcs) {
                // TODO waiting for cert endpoint update
                // if (certs.length && certs.filter((item: any): boolean => item.acdId === adc.id)) {
                this.tableRows.push({
                    id: adc.id,
                    label: adc.label,
                    vendor: adc.vendor
                });
                // }
            }
        }
    }

    /**
     * Register the page's buttons for RBAC.
     * @private
     */
    private registerButtons(): void {
        const buttonReference = {
            'certificate-more-details': [{ path: '/api/v1/:namespace/security/certificates/:adcid', methods: ['GET'] }]
        };

        this.permissionsLookup = this.rbacService.getPermissionsLookup(buttonReference);
    }
}
